import React from 'react';
import Auth from './Auth';
import { useAuth } from '../AuthContext';

/** Shows the login form instead of its children until someone is signed in. */
export default function Protected({ children }: { children: React.ReactNode }): JSX.Element {
  const { username, loading } = useAuth();

  if (loading) {
    return (
      <div className="card">
        <p>Loading…</p>
      </div>
    );
  }

  if (!username) return <Auth />;

  return <>{children}</>;
}
